import React, { useEffect, useState } from "react";
import { ProtectedLayout } from "../../layouts";
import {
  DeleteModal,
  IconButton,
  Loader,
  Titlebar,
} from "../../components";
import DataTable from "react-data-table-component";
import { RateService } from "../../service";
import { toast } from "react-toastify";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";


const EditRate = ({id}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/rate/${id}`);
  }
  return (
    <IconButton icon={<FaEdit className="menu-icon text-warning"/>} onClick={handleClick} />
  )
}
export default function GetRate() {
  const [pending, setPending] = useState(true);
  const [blogs, setBlogs] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);

  const columns = [
    {
      name: "Rate",
      selector: (row) => row.rate,  
      cell: (row) => {
        return (
          <div className="d-flex gap-2">
            <span>{row.rate}</span>
          </div>
        );
      },
    },
    {
      name: "Actions",
      cell: (row) => {
        return (
          <div className="d-flex gap-2">
            <EditRate id={row._id}/>
            <DeleteModal itemName="GetRate" id={row._id} onDelete={onDelete} />
          </div>
        );
      },
    },
  ];




  const onDelete = async (id) => {
    try{
      await RateService.delete(id);
      let list = blogs.filter((item) => item._id !== id);
      setBlogs(list);
      toast.success("Rate successfully deleted!");
    } catch(error){
      toast.error("Error while deleting blog data!");
    }
  }

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        let response = await RateService.get();
        console.log(response, "rate Data");
        let result = response.data.data;
        setBlogs(result);
        setFilteredBlogs(result);
      } catch (error) {
        console.log(error);
        toast.error("Error while fecthing data!");
      } finally {
        setPending(false);
      }
    };
    fetchAgents();
  }, []);

  return (
    <ProtectedLayout>
      <Titlebar title="Get Rate">
      </Titlebar>
      <DataTable
        columns={columns}
        data={filteredBlogs}
        progressPending={pending}
        progressComponent={<Loader />}
        pagination
        responsive
      />
    </ProtectedLayout>
  );
}
